module.exports = __webpack_public_path__ + "img/maintain-facility.e635632b.svg";